<template>
  <div class="matrix-row">
    <div class="description">
      <span class="prod-code">{{ variant.id }}</span>
      <span class="prod-desc">{{ variant.shortDescription }}</span>
    </div>

    <div class="properties" v-for="property in properties" v-bind:key="property">
        {{variant.properties[property]}}
    </div>

    <div class="prod-price">
      <div class="ph-product-price" v-if="variant != undefined && variant.prices != undefined && variant.prices.length">
        <utlz-product-price
          :prices="pricePerVolume"
        ></utlz-product-price>
      </div>
    </div>

    <div v-if="showStock" class="prod-stock">
      <utlz-product-stock
        :stock="variant.stock"
        :stockTotal="variant.stock"
      ></utlz-product-stock>
    </div>

    <div class="order">
      <utlz-order-product
        v-if="showOrderProduct"
        :product="variant"
        :allowZeroQuantity="true"
        :useOrderMode="false"
        @quantityChanged="quantityChanged($event)"
        @unitsChanged="unitsChanged($event)"
      ></utlz-order-product>
    </div>

</div>
</template>

<script>

// BESPOKE
import { mapGetters } from 'vuex';
import { GetPricePerVolume } from 'src/services/product-service';
import OrderProduct from 'src/components/webshop/order-product/OrderProduct.vue';
import ProductPrice from 'src/components/webshop/product-price/ProductPrice.vue';
import ProductStock from 'src/components/webshop/product-stock/ProductStock.vue';
// END BESPOKE
export default {
  props: {
    variant: { type: Object, required: true }
  },
  components: {
    'utlz-order-product': OrderProduct,
    'utlz-product-price': ProductPrice,
    'utlz-product-stock': ProductStock
  },
  data() {
    return {
      userSelectedQuantity: 1
    }
  },
  computed: {
    ...mapGetters(['showStock', 'userLoggedOn', 'showOrderProduct', 'showPrices']),
    properties () {
      if (this.variant != undefined) {
        return Object.keys(this.variant.properties);
      }
      return [];
    },
    // BESPOKE TBH-17
    pricePerVolume() {
      return GetPricePerVolume(this.variant.prices ,this.variant.units, this.userSelectedQuantity);
    }
    // END BESPOKE TBH-17
  },
  methods: {
    // BESPOKE TBH-17
    quantityChanged(event) {
      this.userSelectedQuantity = event.userSelectedQuantity;
      this.$emit('quantityChanged', event, this.variant)
    },
    unitsChanged(event) {
      this.$emit('unitsChanged', event, this.variant);
    }
  }
}
</script>

<style>

</style>